import styled from "styled-components";
import compactSidebarCards from "./sidebarCardsCompact";

/*
  Sidebar izquierdo del editor de campaña.
  - >= 1200px: columna que fluye con la página, sin scroll propio (si no entra, crece el body).
  - 768-1199px: bloque arriba del contenido, cards en grilla de 2 columnas.
  - < 768px: columna angosta (50% del ancho) con cards apiladas.
  El botón "Volver/Mapa" se vuelve fijo abajo en < 1200px (ver campaignManagerStyle).
*/
const LeftSideStyleHolder = styled.div`
    position: relative;
    padding-top: 25px;
    height: 100%;

    .leftSideContainer {
        display: flex;
        flex-direction: column;
        gap: 10px;
        width: 100%;
    }

    .leftSideCards {
        display: flex;
        flex-direction: column;
        gap: 12px;
        min-width: 0;
    }

    /* Cualquier card vacía (ej. sin audiencia) no debe dejar hueco */
    .leftSideCards > *:empty {
        display: none;
    }

    @media only screen and (min-width: 768px) and (max-width: 1199px) {
        padding-top: 10px;
    }

    .leftSideCards {
        ${compactSidebarCards}
    }

    @media only screen and (max-width: 767px) {
        padding-top: 10px;
    }
    @media only screen and (max-width: 575px) {
        padding-top: 0;
        height: auto;
    }
`;

export default LeftSideStyleHolder;
